<i class="ion ion-md-lock"></i>
<tooltip-popover *ngIf="lock_description"
                 [tooltip_content]="lock_description">
</tooltip-popover>
